module.exports = __webpack_public_path__ + "font3.7273b7d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/font3.png
// module id = Gla2
// module chunks = 0